
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modules/[module]/[lesson]",
      function () {
        return require("private-next-pages/modules/[module]/[lesson]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modules/[module]/[lesson]"])
      });
    }
  